<template>
  <section class="ArchiveActionSection">
    <slot />
  </section>
</template>

<script>
import './style.scss'

export default {
  name: 'ArchiveActionSection',
}
</script>
